import { JourneyChoiceGrid as ChoiceGrid } from "../controls";

const BASED_OPTIONS = [
  ["uk", "UK", "I currently live in the United Kingdom"],
  ["outside_uk", "Outside UK", "I currently live outside the United Kingdom"],
];

export const BasedStep = ({ value, onChange }) => (
  <div>
    <h2 className="font-display text-3xl font-bold tracking-tight text-ink">Where are you currently based?</h2>
    <p className="mt-2 text-sm leading-6 text-slatey">This helps OpenDegree show you the right opportunities and pathway. It is about where you live now — not your nationality or immigration status.</p>
    <div className="mt-6">
      <ChoiceGrid options={BASED_OPTIONS} value={value} onChange={onChange} testId="journey-based" />
    </div>
  </div>
);
